export default "__VITE_ASSET__881bf773__"